<template>
  <!-- 配送计划底部修改时间按钮 -->
  <div class="btn_con">
    <div
      v-if="getDistributionPlan.status === 0"
      class="font12 font_weight400 colo055 exp_det"
    >
      注：「修改下期配送时间」，之后其他期将顺延
    </div>
    <div
      v-if="getDistributionPlan.status === 0"
      class="btn font14 font_weight400 colo087 line_height_50"
    >
      <div class="flex_item flex_item1" @click="goChooseDate">
        修改下期配送时间
      </div>
      <div
        v-if="getDistributionPlan.status === 0"
        class="flex_item flex_item2 colof font_weight500"
        @click="stopDate"
      >
        暂停配送
      </div>
      <div
        v-if="getDistributionPlan.status === 1"
        class="flex_item flex_item2 colof font_weight500"
        @click="containDate"
      >
        恢复配送
      </div>
    </div>
    <div
      v-if="getDistributionPlan.status === 1"
      class="font14 line_height_50 colof font_weight500 btn_2"
      @click="containDate"
    >
      恢复配送
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getDistributionPlan() {
      return this.$store.getters.getDistributionPlan;
    }
  },
  methods: {
    stopDate() {
      this.$emit("stopDate");
    },
    goChooseDate() {
      this.$emit("goChooseDate");
    },
    containDate() {
      this.$emit("containDate");
    }
  }
};
</script>

<style lang="less" scoped>
.btn_con {
  padding: 12px;
  .exp_det {
    padding-bottom: 12px;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    .flex_item1 {
      margin-right: 12px;
      border-radius: 2px;
      border: 1px solid #000;
    }
    .flex_item2 {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 2px;
    }
    .flex_item {
      flex: 1;
    }
  }
  .btn_2 {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
  }
}
</style>
